import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { ProgressBarLayout as Component } from '../layouts/default';
import type { TProgressLayout, IDepsDefault } from '../models';
import { CallToAction } from '../components/call-to-action';
import { ProgressBar } from '../components/progress-bar';
import { Slogan } from '../components/slogan';

import styles from './desktop.css';
import { wrapperClassNamesHelperDesktop } from './helpers';

export const ProgressBarLayout = createWidget<IDepsDefault, TProgressLayout>({
    CallToAction,
    ProgressBar,
    Slogan,
    Text,
    styles,
    wrapperClassNamesHelper: wrapperClassNamesHelperDesktop,
})(Component);
